import React from "react";
import breakpoints from "./breakpoints";

const devices = {
    mobile : `(max-width: ${breakpoints.md})`,
    desktop : `(max-width: ${breakpoints.xl})`
}

export default devices;